import React from 'react';
import Amplify from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAllSettlement } from '../../../Actions/actions';
import * as SecretKeys from '../../../ENV.json';
import LandingPage from './landingPage';

Amplify.configure(SecretKeys.awsUserpool);
const userid = localStorage.getItem('userId');

class landingPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      // this.forceUpdate();
      return true;
    }
    return false;
  }

  scrollStep=() => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  saveEnrichmentAnswer(queId, ans) {
    const data = { userId: userid, value: ans, enrichmentQuestionId: queId };
    this.props.saveEnrichmentAnswer(data);
  }

  componentWillMount() {
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({
      intervalId,
    });
  }

  render() {
    // const {} = this.state;

    return (
      <LandingPage
        affiliateId={this.props.match.params.affiliateId}
        partnerType={this.props.match.params.partnerType}
      />
    );
  }
}

landingPageContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllSettlement }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(landingPageContainer));
